import { createAction, props } from '@ngrx/store';
import {
  Document,
  DocumentDetail,
  DocumentListItem,
  PaginatedDocuments,
  DocumentUploadResponse,
  PresignedUrlResponse,
  DocumentFilters,
  UploadProgress
} from '../models/document.models';

/**
 * Document Actions
 */

// Load Documents List
export const loadDocuments = createAction(
  '[Documents] Load Documents',
  props<{ filters: DocumentFilters }>()
);

export const loadDocumentsSuccess = createAction(
  '[Documents] Load Documents Success',
  props<{ data: PaginatedDocuments }>()
);

export const loadDocumentsFailure = createAction(
  '[Documents] Load Documents Failure',
  props<{ error: string }>()
);

// Load Single Document
export const loadDocument = createAction(
  '[Documents] Load Document',
  props<{ documentId: string }>()
);

export const loadDocumentSuccess = createAction(
  '[Documents] Load Document Success',
  props<{ document: Document }>()
);

export const loadDocumentFailure = createAction(
  '[Documents] Load Document Failure',
  props<{ error: string }>()
);

// Upload Document
export const uploadDocument = createAction(
  '[Documents] Upload Document',
  props<{ file: File; templateId?: string; tags?: string[] }>()
);

export const uploadDocumentProgress = createAction(
  '[Documents] Upload Document Progress',
  props<{ file: File; progress: number }>()
);

export const uploadDocumentSuccess = createAction(
  '[Documents] Upload Document Success',
  props<{ response: DocumentUploadResponse }>()
);

export const uploadDocumentFailure = createAction(
  '[Documents] Upload Document Failure',
  props<{ file: File; error: string }>()
);

export const cancelUpload = createAction(
  '[Documents] Cancel Upload',
  props<{ file: File }>()
);

// Large File Upload (Presigned URL)
export const uploadLargeDocument = createAction(
  '[Documents] Upload Large Document',
  props<{ file: File; templateId?: string; tags?: string[] }>()
);

export const uploadLargeDocumentProgress = createAction(
  '[Documents] Upload Large Document Progress',
  props<{ file: File; progress: number }>()
);

export const uploadLargeDocumentSuccess = createAction(
  '[Documents] Upload Large Document Success',
  props<{ file: File; documentId: string }>()
);

export const uploadLargeDocumentFailure = createAction(
  '[Documents] Upload Large Document Failure',
  props<{ file: File; error: string }>()
);

// Delete Document
export const deleteDocument = createAction(
  '[Documents] Delete Document',
  props<{ documentId: string; permanent?: boolean }>()
);

export const deleteDocumentSuccess = createAction(
  '[Documents] Delete Document Success',
  props<{ documentId: string }>()
);

export const deleteDocumentFailure = createAction(
  '[Documents] Delete Document Failure',
  props<{ error: string }>()
);

// Bulk Delete
export const bulkDeleteDocuments = createAction(
  '[Documents] Bulk Delete Documents',
  props<{ documentIds: string[]; permanent?: boolean }>()
);

export const bulkDeleteDocumentsSuccess = createAction(
  '[Documents] Bulk Delete Documents Success',
  props<{ documentIds: string[] }>()
);

export const bulkDeleteDocumentsFailure = createAction(
  '[Documents] Bulk Delete Documents Failure',
  props<{ error: string }>()
);

// Update Filters
export const updateFilters = createAction(
  '[Documents] Update Filters',
  props<{ filters: Partial<DocumentFilters> }>()
);

// Clear State
export const clearDocuments = createAction(
  '[Documents] Clear Documents'
);

export const clearSelectedDocument = createAction(
  '[Documents] Clear Selected Document'
);

export const clearUploadQueue = createAction(
  '[Documents] Clear Upload Queue'
);

// Load Document Detail
export const loadDocumentDetail = createAction(
  '[Documents] Load Document Detail',
  props<{ documentId: string }>()
);

export const loadDocumentDetailSuccess = createAction(
  '[Documents] Load Document Detail Success',
  props<{ document: DocumentDetail }>()
);

export const loadDocumentDetailFailure = createAction(
  '[Documents] Load Document Detail Failure',
  props<{ error: string }>()
);

